import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { AUDIO_AREA_HEIGHT, AUDIO_AREA_WIDTH } from 'constants/style';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: AUDIO_AREA_WIDTH,
      height: AUDIO_AREA_HEIGHT,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1),
    },
    fileNameContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: AUDIO_AREA_WIDTH,
      height: AUDIO_AREA_HEIGHT,
      backgroundColor: theme.palette.background.default,
      borderRadius: theme.spacing(1),
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      cursor: 'pointer',
    },
    fileName: {
      cursor: 'pointer',
      wordBreak: 'break-all',
      textAlign: 'center',
      padding: theme.spacing(0, 2),
      color: theme.palette.text.secondary,
    },
    subtitle: {
      color: theme.palette.text.disabled,
    },
    input: {
      display: 'none',
    },
  }),
);

export default useStyles;
